const LEAD_ROLE_CONFIG = {
  default: {
    customerPage: {
      tabs: ["Clients", "Requests", "Users", "Groups"],
      defaultTab: "Clients",
    },
    leadsTable: {
      columns: ["borrowerName", "inn", "requestedAmount", "requestedTermMonths", "stopFactors", "rating", "status", "actions"],
      showNewLeadButton: true,
      actions: {
        showRequests: true,
        showView: true,
        showReport: true,
        showEdit: true,
        showDetails: true,
        showDelete: true,
      },
    },
    transfersTable: {
      columns: ["leadReceiverCustomerName", "requestedAmount", "requestedTermMonths", "createdAt", "creditIssuedAt", "bankDecisionAt", "status", "actions"],
      statusEditable: false,
      showNewTransferButton: true,
      actions: {
        showDetails: true,
      },
    },
    requestsTab: {
      showUploadButton: true,
    },
  },
  LeadGenerator: {
    customerPage: {
      tabs: ["Leads", "Users"],
      defaultTab: "Leads",
    },
    leadsTable: {
      columns: ["borrowerName", "inn", "requestedAmount", "requestedTermMonths", "stopFactors", "rating", "status", "actions"],
      showNewLeadButton: true,
      actions: {
        showRequests: true,
        showView: true,
        showReport: true,
        showEdit: true,
        showDetails: true,
        showDelete: true,
      },
    },
    transfersTable: {
      columns: ["leadReceiverCustomerName", "requestedAmount", "requestedTermMonths", "createdAt", "creditIssuedAt", "bankDecisionAt", "status", "actions"],
      statusEditable: false,
      showNewTransferButton: true,
      actions: {
        showDetails: true,
      },
    },
    requestsTab: {
      showUploadButton: true,
    },
  },
  LeadReceiver: {
    customerPage: {
      tabs: ["Leads", "Clients", "Requests", "Users", "Groups"],
      defaultTab: "Leads",
    },
    leadsTable: {
      columns: ["borrowerName", "inn", "requestedAmount", "requestedTermMonths", "stopFactors", "rating", "actions"],
      showNewLeadButton: false,
      actions: {
        showRequests: true,
        showView: true,
        showReport: false,
        showEdit: false,
        showDetails: true,
        showDelete: false,
        showConvert: true,
      },
    },
    transfersTable: {
      columns: ["leadReceiverCustomerName", "requestedAmount", "requestedTermMonths", "createdAt", "creditIssuedAt", "bankDecisionAt", "status", "actions"],
      statusEditable: true,
      showNewTransferButton: false,
      actions: {
        showDetails: true,
      },
    },
    requestsTab: {
      showUploadButton: false,
    },
  },
};

export const getLeadRoleConfig = (role) =>
  LEAD_ROLE_CONFIG[role] ?? LEAD_ROLE_CONFIG.default;
